var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297 48",
    style: {
      enableBackground: "new 0 0 297 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61,28.8c-1.5,0-2.8-0.2-4-0.7c-1.2-0.5-2.2-1.2-3-2.1l3.4-4c0.5,0.6,1,1.1,1.5,1.4c0.5,0.3,1,0.5,1.5,0.5 c1.4,0,2.1-0.8,2.1-2.3v-7.2h-6.4V9.5h12.7v11.6c0,2.6-0.7,4.5-2,5.8C65.5,28.2,63.5,28.8,61,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.3,28.4l8.3-18.9h6.3L92,28.4h-6.6l-6.1-15.9h2.5l-6.1,15.9H69.3z M74.2,25.1l1.6-4.6h8.7l1.6,4.6H74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.1,28.4V9.5h9.3c2.1,0,4,0.4,5.6,1.1c1.6,0.8,2.9,1.8,3.8,3.3c0.9,1.4,1.4,3.1,1.4,5c0,2-0.5,3.6-1.4,5.1 c-0.9,1.4-2.2,2.5-3.8,3.3c-1.6,0.8-3.5,1.1-5.6,1.1H93.1z M99.4,23.4h2.7c0.9,0,1.7-0.2,2.4-0.5s1.2-0.9,1.6-1.5s0.6-1.5,0.6-2.5 c0-1-0.2-1.8-0.6-2.4c-0.4-0.7-0.9-1.2-1.6-1.5s-1.5-0.5-2.4-0.5h-2.7V23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.6,23.6h9.4v4.8h-15.7V9.5h15.4v4.8h-9.1V23.6z M121.2,16.5h8.4v4.6h-8.4V16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.8,23.6h9.4v4.8h-15.7V9.5h15.4v4.8h-9.1V23.6z M139.4,16.5h8.4v4.6h-8.4V16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.7,28.4V9.5h9.3c2.1,0,4,0.4,5.6,1.1c1.6,0.8,2.9,1.8,3.8,3.3c0.9,1.4,1.3,3.1,1.3,5c0,2-0.5,3.6-1.3,5.1 c-0.9,1.4-2.2,2.5-3.8,3.3c-1.6,0.8-3.5,1.1-5.6,1.1H151.7z M158.1,23.4h2.7c0.9,0,1.7-0.2,2.4-0.5s1.2-0.9,1.6-1.5 s0.6-1.5,0.6-2.5c0-1-0.2-1.8-0.6-2.4c-0.4-0.7-0.9-1.2-1.6-1.5s-1.5-0.5-2.4-0.5h-2.7V23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.1,28.4V9.5h5.2l7.6,12.3h-2.8l7.3-12.3h5.2l0.1,18.9H199l-0.1-10.1h0.9l-5,8.4H192l-5.2-8.4h1.1v10.1 H182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.9,28.8c-2.9,0-5.2-0.8-6.8-2.3c-1.6-1.6-2.4-3.8-2.4-6.6V9.5h6.4v10.2c0,1.4,0.3,2.5,0.8,3.1 c0.5,0.6,1.2,0.9,2.1,0.9c0.9,0,1.6-0.3,2.1-0.9s0.8-1.6,0.8-3.1V9.5h6.3v10.4c0,2.8-0.8,5-2.4,6.6 C222,28.1,219.8,28.8,216.9,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229,28.4V9.5h5.2l9.6,11.5h-2.4V9.5h6.2v18.9h-5.2l-9.6-11.5h2.4v11.5H229z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.8,28.8c-1.6,0-3.1-0.2-4.6-0.5c-1.5-0.4-2.7-0.8-3.6-1.4l2.1-4.6c0.9,0.5,1.9,0.9,3,1.3 c1.1,0.3,2.2,0.5,3.2,0.5c0.6,0,1.1,0,1.4-0.1s0.6-0.2,0.8-0.4c0.2-0.2,0.2-0.3,0.2-0.6c0-0.3-0.2-0.6-0.6-0.8 c-0.4-0.2-0.9-0.4-1.5-0.5s-1.3-0.3-2-0.4c-0.7-0.2-1.5-0.4-2.2-0.6c-0.7-0.3-1.4-0.6-2.1-1c-0.6-0.4-1.1-1-1.5-1.6 s-0.6-1.5-0.6-2.5c0-1.2,0.3-2.2,1-3.2c0.7-1,1.6-1.7,2.9-2.3c1.3-0.6,2.9-0.9,4.9-0.9c1.3,0,2.5,0.1,3.8,0.4 c1.2,0.3,2.4,0.7,3.3,1.2l-1.9,4.6c-0.9-0.5-1.8-0.8-2.7-1.1s-1.7-0.4-2.6-0.4c-0.6,0-1.1,0.1-1.5,0.2c-0.4,0.1-0.6,0.3-0.8,0.4 c-0.2,0.2-0.2,0.4-0.2,0.6c0,0.3,0.2,0.6,0.6,0.8s0.9,0.3,1.5,0.5c0.6,0.1,1.3,0.3,2.1,0.4c0.7,0.1,1.5,0.3,2.2,0.6 c0.7,0.3,1.4,0.6,2,1c0.6,0.4,1.1,1,1.5,1.6c0.4,0.7,0.6,1.5,0.6,2.5c0,1.2-0.3,2.2-1,3.2c-0.7,1-1.6,1.7-2.9,2.3 S259.7,28.8,257.8,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.8,28.4h-6.4V9.5h6.4V28.4z M281.1,21.4h-6.7v-5.2h6.7V21.4z M280.7,9.5h6.4v18.9h-6.4V9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.1,28.4V9.5h6.4v18.9H290.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.9,35.2l-1.3,1.2c-0.9-0.9-1.9-1.4-3-1.4c-0.9,0-1.7,0.3-2.4,0.9c-0.6,0.6-1,1.4-1,2.3 c0,0.6,0.1,1.2,0.4,1.7c0.3,0.5,0.7,0.9,1.2,1.2c0.5,0.3,1.1,0.4,1.7,0.4c0.5,0,1-0.1,1.5-0.3c0.4-0.2,0.9-0.6,1.5-1.1l1.3,1.3 c-0.7,0.7-1.4,1.2-2,1.4s-1.4,0.4-2.2,0.4c-1.5,0-2.8-0.5-3.7-1.4c-1-0.9-1.4-2.2-1.4-3.6c0-1,0.2-1.8,0.7-2.5 c0.4-0.7,1.1-1.3,1.9-1.8c0.8-0.5,1.7-0.7,2.6-0.7c0.8,0,1.6,0.2,2.3,0.5S63.4,34.6,63.9,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.4,33.3c1.4,0,2.6,0.5,3.6,1.5c1,1,1.5,2.2,1.5,3.6c0,1.4-0.5,2.6-1.5,3.5c-1,1-2.2,1.4-3.6,1.4 c-1.5,0-2.7-0.5-3.6-1.5c-1-1-1.5-2.2-1.5-3.5c0-0.9,0.2-1.8,0.7-2.5c0.5-0.8,1.1-1.4,1.9-1.8C69.6,33.5,70.5,33.3,71.4,33.3z  M71.4,35.1c-0.9,0-1.7,0.3-2.3,0.9c-0.6,0.6-0.9,1.4-0.9,2.3c0,1.1,0.4,1.9,1.2,2.5c0.6,0.5,1.3,0.7,2.1,0.7 c0.9,0,1.6-0.3,2.2-0.9c0.6-0.6,0.9-1.4,0.9-2.3c0-0.9-0.3-1.7-0.9-2.3C73,35.4,72.3,35.1,71.4,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.4,33.5h1.8l2.3,6.7l2.3-6.7h1.8l1.6,9.6h-1.8l-1-6l-2.1,6h-1.6l-2.1-6l-1.1,6h-1.8L80.4,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.9,33.5h2c1.1,0,1.8,0.1,2.3,0.3c0.5,0.2,0.8,0.5,1.1,0.9c0.3,0.4,0.4,0.9,0.4,1.5c0,0.7-0.2,1.2-0.5,1.7 c-0.4,0.4-0.8,0.8-1.4,0.9c-0.4,0.1-1,0.1-2,0.1v4h-1.9V33.5z M94.8,37.3h0.6c0.5,0,0.8,0,1-0.1c0.2-0.1,0.3-0.2,0.4-0.3 c0.1-0.2,0.2-0.3,0.2-0.5c0-0.4-0.1-0.6-0.4-0.8c-0.2-0.1-0.6-0.2-1.2-0.2h-0.5V37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.8,33.5h1.9v7.8h2.7v1.7h-4.6V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109,33.5h5.3v1.8h-3.5v1.7h3.5v1.7h-3.5v2.5h3.5v1.8H109V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.3,33.5h5.4v1.8H120v7.8h-1.9v-7.8h-1.7V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.3,33.5h5.3v1.8h-3.5v1.7h3.5v1.7h-3.5v2.5h3.5v1.8h-5.3V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.6,33.5h4.8v1.8h-3v1.7h3v1.7h-3v4.3h-1.8V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.2,33.5h1.8v9.6h-1.8V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.4,33.5h1.8l4.2,6.3v-6.3h1.9v9.6h-1.8l-4.2-6.3v6.3h-1.9V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.7,33.5h1.9l3.8,9.6h-1.9l-0.8-2h-4l-0.8,2h-1.9L164.7,33.5z M165.6,36.1l-1.3,3.3h2.6L165.6,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173,33.5h1.8l4.2,6.3v-6.3h1.9v9.6H179l-4.2-6.3v6.3H173V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.3,35.2l-1.3,1.2c-0.9-0.9-1.9-1.4-3-1.4c-0.9,0-1.7,0.3-2.4,0.9c-0.6,0.6-1,1.4-1,2.3 c0,0.6,0.1,1.2,0.4,1.7c0.3,0.5,0.7,0.9,1.2,1.2c0.5,0.3,1.1,0.4,1.7,0.4c0.5,0,1-0.1,1.5-0.3c0.4-0.2,0.9-0.6,1.5-1.1l1.3,1.3 c-0.7,0.7-1.4,1.2-2,1.4s-1.4,0.4-2.2,0.4c-1.5,0-2.8-0.5-3.7-1.4s-1.4-2.2-1.4-3.6c0-1,0.2-1.8,0.7-2.5c0.4-0.7,1.1-1.3,1.9-1.8 c0.8-0.5,1.7-0.7,2.6-0.7c0.8,0,1.6,0.2,2.3,0.5C192.1,34.1,192.7,34.6,193.3,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196,33.5h1.8v9.6H196V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.2,33.5h1.9l3.8,9.6h-1.9l-0.8-2h-4l-0.8,2h-1.9L204.2,33.5z M205.1,36.1l-1.3,3.3h2.6L205.1,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.5,33.5h1.9v7.8h2.7v1.7h-4.6V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.9,34.8l-1.4,1.2c-0.5-0.7-1-1-1.5-1c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.2,0.3-0.2,0.4 c0,0.2,0.1,0.3,0.2,0.5c0.2,0.2,0.6,0.6,1.4,1.2c0.7,0.6,1.1,0.9,1.3,1.1c0.4,0.4,0.6,0.7,0.8,1.1s0.2,0.7,0.2,1.1 c0,0.8-0.3,1.4-0.8,1.9c-0.6,0.5-1.3,0.8-2.2,0.8c-0.7,0-1.3-0.2-1.8-0.5c-0.5-0.3-1-0.9-1.3-1.6l1.6-0.9c0.5,0.8,1,1.3,1.6,1.3 c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.4,0.3-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.5-0.5-1.1-1c-1.1-0.8-1.7-1.5-2.1-2 c-0.3-0.5-0.5-0.9-0.5-1.4c0-0.7,0.3-1.2,0.8-1.7c0.5-0.5,1.2-0.7,1.9-0.7c0.5,0,1,0.1,1.4,0.3C228.9,33.9,229.4,34.3,229.9,34.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.7,33.3c1.4,0,2.6,0.5,3.6,1.5c1,1,1.5,2.2,1.5,3.6c0,1.4-0.5,2.6-1.5,3.5c-1,1-2.2,1.4-3.6,1.4 c-1.5,0-2.7-0.5-3.6-1.5c-1-1-1.5-2.2-1.5-3.5c0-0.9,0.2-1.8,0.7-2.5c0.5-0.8,1.1-1.4,1.9-1.8C235.9,33.5,236.7,33.3,237.7,33.3z  M237.6,35.1c-0.9,0-1.7,0.3-2.3,0.9s-0.9,1.4-0.9,2.3c0,1.1,0.4,1.9,1.2,2.5c0.6,0.5,1.3,0.7,2.1,0.7c0.9,0,1.6-0.3,2.2-0.9 c0.6-0.6,0.9-1.4,0.9-2.3c0-0.9-0.3-1.7-0.9-2.3C239.3,35.4,238.5,35.1,237.6,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.7,33.5h1.9v7.8h2.7v1.7h-4.6V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.9,33.5h1.9v6.2c0,0.5,0,0.9,0.1,1.1s0.3,0.4,0.5,0.5s0.5,0.2,0.8,0.2c0.3,0,0.6-0.1,0.8-0.2 s0.4-0.3,0.5-0.6c0.1-0.2,0.1-0.7,0.1-1.3v-6h1.9v5.7c0,1-0.1,1.6-0.2,2c-0.1,0.4-0.3,0.7-0.6,1.1c-0.3,0.3-0.7,0.6-1.1,0.8 c-0.4,0.2-0.9,0.2-1.4,0.2c-0.7,0-1.3-0.2-1.8-0.5c-0.5-0.3-0.9-0.7-1.1-1.2s-0.3-1.3-0.3-2.4V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.9,33.5h5.4v1.8h-1.8v7.8h-1.9v-7.8h-1.7V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.7,33.5h1.8v9.6h-1.8V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.5,33.3c1.4,0,2.6,0.5,3.6,1.5c1,1,1.5,2.2,1.5,3.6c0,1.4-0.5,2.6-1.5,3.5c-1,1-2.2,1.4-3.6,1.4 c-1.5,0-2.7-0.5-3.6-1.5c-1-1-1.5-2.2-1.5-3.5c0-0.9,0.2-1.8,0.7-2.5c0.5-0.8,1.1-1.4,1.9-1.8C277.7,33.5,278.6,33.3,279.5,33.3z  M279.5,35.1c-0.9,0-1.7,0.3-2.3,0.9s-0.9,1.4-0.9,2.3c0,1.1,0.4,1.9,1.2,2.5c0.6,0.5,1.3,0.7,2.1,0.7c0.9,0,1.6-0.3,2.2-0.9 c0.6-0.6,0.9-1.4,0.9-2.3c0-0.9-0.3-1.7-0.9-2.3C281.1,35.4,280.3,35.1,279.5,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.5,33.5h1.8l4.2,6.3v-6.3h1.9v9.6h-1.8l-4.2-6.3v6.3h-1.9V33.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.9,0.1H4.8C2.4,0.1,0.5,2,0.5,4.4v39.1c0,2.4,1.9,4.3,4.3,4.3h39.1c2.4,0,4.3-1.9,4.3-4.3V4.4 C48.2,2,46.3,0.1,43.9,0.1z M20.5,26.7c0,2.4-0.6,4.3-1.8,5.5c-1.2,1.2-3,1.8-5.3,1.8c-1.3,0-2.6-0.2-3.7-0.7 c-1.1-0.5-2-1.2-2.7-2.2l2.5-3c0.5,0.7,1.1,1.3,1.7,1.6c0.6,0.4,1.3,0.5,2,0.5c1.9,0,2.8-1.1,2.8-3.2v-9.4H9.1v-3.7h11.5V26.7z  M29.5,34.1l-7.3-20.1h4.6l7.3,20.1H29.5z M37.1,34.1l-7.3-20.1h4.6l7.3,20.1H37.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowhite);
export default __webpack_public_path__ + "static/media/logowhite.8e699fe91d1e462f63216ac8b97bd58f.svg";
export { ForwardRef as ReactComponent };